import { ApiError } from '../lib/api'

/**
 * Friendly error surface with a retry. A forbidden response renders a plain
 * access message — it never echoes back any object id from the request
 * (011.B §5 — no object-id leak from a forbidden project).
 */
export function ErrorCard({
  error,
  onRetry,
}: {
  error: unknown
  onRetry?: () => void
}): JSX.Element {
  let title = 'Something went wrong'
  let message = 'We could not load this just now. Please try again.'

  if (error instanceof ApiError) {
    if (error.status === 401) {
      title = 'Session expired'
      message = 'Please refresh the page to sign in again.'
    } else if (error.status === 403) {
      title = 'Not available'
      message = "This isn't part of your project portal."
    } else if (error.status === 404) {
      title = 'Not found'
      message = 'That item is no longer available.'
    }
  }

  return (
    <div className="card error-card" role="alert">
      <h3>{title}</h3>
      <p>{message}</p>
      {onRetry && (
        <button type="button" className="btn" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  )
}
